import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';

export const Root = styled('div', {
	shouldForwardProp: (prop) => prop !== 'hidden',
})<{ hidden: boolean }>(({ theme, hidden }) => ({
	backgroundColor: theme.palette.neutral[0],
	width: '100%',
	height: '100%',
	display: 'grid',
	gridTemplateRows: 'max-content 1fr max-content',
	visibility: hidden ? 'hidden' : 'visible',
	maxWidth: MOBILE_CONTAINER_WIDTH,
	margin: 'auto',
	boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
	overflow: 'hidden',
}));

export const ScrollWrapper = styled('div')(() => ({
	display: 'grid',
	height: '100%',
	overflow: 'auto',
}));

export const LoaderWrapper = styled('div')(() => ({
	position: 'fixed',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	zIndex: 1200,
}));
